import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import GlobalNotice from "./global-notice"

export default (props) => {
  const { globalNotice, translations } = useStaticQuery(graphql`
    query {
      globalNotice {
        id
        text
        show
        link
        level
        relatedNews: related_news {
          path
        }
        relatedArticle: related_article {
          path
        }
        relatedEvent: related_event {
          path
        }
      }

      translations: translationsJson {
        global {
          showMore
          close
        }
      }
    }
  `)

  return (
    <GlobalNotice {...props} data={globalNotice} translations={translations} />
  )
}
